import { useEffect, useState } from 'react'
import type { TenantBootstrapModel } from '@unified-lk/tenant-config'
import { needsAuthedPreviewFetch } from './resolvePhotoPreviewSrc'
import { schedulePreviewFetch } from './previewFetchQueue'

export function useAuthedPreviewUrl(
  src: string | null,
  accessToken: string | undefined,
  bootstrap: TenantBootstrapModel,
): string | null {
  const [displaySrc, setDisplaySrc] = useState<string | null>(null)

  useEffect(() => {
    if (!src) {
      setDisplaySrc(null)
      return
    }

    if (!needsAuthedPreviewFetch(src, bootstrap.apiBase)) {
      setDisplaySrc(src)
      return
    }

    if (!accessToken) {
      setDisplaySrc(null)
      return
    }

    let objectUrl = ''
    let cancelled = false

    void schedulePreviewFetch(async () => {
      const res = await fetch(src, { headers: { Authorization: `Bearer ${accessToken}` } })
      if (!res.ok) throw new Error(String(res.status))
      return res.blob()
    })
      .then((blob) => {
        if (cancelled) return
        objectUrl = URL.createObjectURL(blob)
        setDisplaySrc(objectUrl)
      })
      .catch(() => {
        if (!cancelled) setDisplaySrc(null)
      })

    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [src, accessToken, bootstrap.apiBase])

  return displaySrc
}
